import { render, staticRenderFns } from "./StudentDashboard.vue?vue&type=template&id=bfd6e3b4&scoped=true"
import script from "./StudentDashboard.vue?vue&type=script&lang=js"
export * from "./StudentDashboard.vue?vue&type=script&lang=js"
import style0 from "./StudentDashboard.vue?vue&type=style&index=0&id=bfd6e3b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd6e3b4",
  null
  
)

export default component.exports